// src/api/records.ts
import axios from './axiosConfig';

const base = '/api/records';

export interface RecordListParams {
    page?: number;
    per_page?: number;
    search?: string;
    date_from?: string; // "YYYY-MM-DD"
    date_to?: string; // "YYYY-MM-DD"
    creators?: string[];
    drafts?: boolean;
}

export interface RevisionListParams {
    revision_group: string;
}

export interface RecordListItem {
    id: string;
    triplet_id: string;
    title: string;
    record_time: string;
    created_at: string;
    user_email: string;
    attachments_count: number;
    revision_of: string;
    revision_group: string;
}

export interface RecordOut {
    id: `${string}-${string}-${string}-${string}-${string}`;
    triplet_id: string;
    title: string;
    content: string;
    created_at: string;
    record_time: string;
    user_id: string;
    user_email: string;
    attachments: AttachmentOut[];
    draft: boolean;
    revision_of: string;
    revision_group: string;
}

export interface RecordListOut {
    total: number;
    first_date: string;
    last_date: string;
    items: RecordListItem[];
}

export interface AttachmentOut {
    id: string;
    path: string;
    hash: string;
}

export const deleteDraft = async (record: { draftUUID: string }) => {
    const formData = new FormData();

    formData.append('draftUUID', String(record.draftUUID));

    const response = await axios.post(base + '/delete-draft', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });

    return response.data;
};

export const saveRecord = async (recordUUID: string) => {
    const formData = new FormData();
    formData.append('record_uuid', recordUUID);

    const response = await axios.post(base + '/save-record', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });

    return response.data;
};

// export const saveRecord = async (record: {
//     draftUUID?: string;
//     title: string;
//     content: string;
//     record_time?: string;
//     files?: File[];
//     draft: boolean;
//     revision_of?: string;
// }) => {
//     const formData = new FormData();
//     formData.append('title', record.title);
//     formData.append('content', record.content);
//     formData.append('draft', String(record.draft));
//
//     if (record.draftUUID != null) {
//         formData.append('draftUUID', String(record.draftUUID));
//     }
//     record.files?.forEach((file) => formData.append('files', file));
//
//     if (record.record_time) {
//         console.log('record_time', record.record_time);
//         formData.append('record_time', record.record_time);
//     }
//
//     if (record.revision_of) {
//         formData.append('revision_of', record.revision_of);
//     }
//
//     const response = await axios.post(base + '/save-record', formData, {
//         headers: {
//             'Content-Type': 'multipart/form-data',
//         },
//     });
//     return response.data;
// };

export const getRecord = async (id: string): Promise<RecordOut> => {
    const response = await axios.get(`${base}/${id}`);
    return response.data;
};

export const getOriginal = async (id: string) => {
    const response = await axios.get(`${base}/original/${id}`);
    return response.data;
};

export const listRecords = async (
    params: RecordListParams
): Promise<RecordListOut> => {
    const response = await axios.get<RecordListOut>(base, { params });
    return response.data;
};

export const getOffsetRecord = async (recordId: string, offset: number) => {
    const response = await axios.get(`${base}/offset/${recordId}/${offset}`);

    if (response.status == 200) {
        return response.data;
    }

    return null;
};

export const listRevisions = async (
    revision_group: string
): Promise<RecordListOut> => {
    const response = await axios.get(`${base}/revisions`, {
        params: { revision_group },
    });
    return response.data;
};

export const uploadAttachments = async (
    recordUUID: string,
    files: File[]
): Promise<AttachmentOut[]> => {
    const formData = new FormData();
    formData.append('record_uuid', recordUUID);
    files.forEach((file) => formData.append('files', file));
    console.log(formData);

    const response = await axios.post(base + '/upload-attachments', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });

    return response.data;
};

export const deleteAttachment = async (
    attachmentUUID: string
): Promise<AttachmentOut> => {
    const formData = new FormData();
    formData.append('attachment_uuid', attachmentUUID);

    const response = await axios.post(base + '/delete-attachment', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });

    return response.data;
};

export const saveDraft = async (record: {
    recordUUID: string;
    title: string;
    content: string;
    attachment_uuids?: string[];
    record_time: string;
    revision_of?: string;
    revision_group?: string;
}) => {
    const formData = new FormData();
    formData.append('record_uuid', String(record.recordUUID));
    formData.append('title', record.title);
    formData.append('content', record.content);
    formData.append('record_time', record.record_time);
    record.attachment_uuids?.forEach((attachment_uuid) =>
        formData.append('attachment_uuids', attachment_uuid)
    );

    if (record.revision_of) {
        formData.append('revision_of', record.revision_of);
        formData.append('revision_group', record.revision_of);
    }

    const response = await axios.post(base + '/save-draft', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });

    return response.data;
};

export const createRevision = async (recordUUID: string) => {
    const formData = new FormData();
    formData.append('record_uuid', recordUUID);

    const response = await axios.post(base + '/create-revision', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });

    return response.data;
};
